<template>
  <div class="message-setting-layout">
    <div class="message-setting-content">
      <div class="flex align-center justify-between" style=" margin-bottom: 14px">
        <div style="font-weight: bold;">消息设置</div>
        <gj-button type="text" @click="routerMsg('/message/message-center')">查看全部消息</gj-button>
      </div>
      <div style="overflow-y: auto;overflow-x: hidden; padding-right: 6px">
        <gj-area-title>系统消息</gj-area-title>
        <div class="message-content">
          <div class="message-content-row message-content-row-title">
            <div style="flex: 1; padding-left: 40px;">
              消息内容
            </div>
            <div class="content-row-col">
              站内
            </div>
            <div class="content-row-col">
              邮件
            </div>
            <div class="content-row-col">
              微信
            </div>
          </div>
          <div class="message-content-row message-content-row-content">
            <div style="flex: 1; padding-left: 40px;">
              新版本公告
            </div>
            <div class="content-row-col">
              <gj-tooltip content="系统默认不可取消">
                <el-switch disabled v-model="data.publicity.system"></el-switch>
              </gj-tooltip>
            </div>
            <div class="content-row-col">
              <gj-tooltip content="邮件暂不可接收">
                <el-switch disabled v-model="data.publicity.mail"></el-switch>
              </gj-tooltip>
            </div>
            <div class="content-row-col">
              <gj-tooltip content="微信暂不可接收">
                <el-switch disabled v-model="data.publicity.wechat"></el-switch>
              </gj-tooltip>
            </div>
          </div>
        </div>

        <gj-area-title>账户消息</gj-area-title>
        <div class="message-content">
          <div class="message-content-row message-content-row-title">
            <div style="flex: 1; padding-left: 40px;">
              消息内容
            </div>
            <div class="content-row-col">
              站内
            </div>
            <div class="content-row-col">
              邮件
            </div>
            <div class="content-row-col">
              微信
            </div>
          </div>
          <div class="message-content-row message-content-row-content message-solid">
            <div style="flex: 1; padding-left: 40px;">
              充值提醒
            </div>
            <div class="content-row-col">
              <gj-tooltip content="系统默认不可取消">
                <el-switch disabled @change="debounceUpdate" v-model="data.topUpWarning.system"></el-switch>
              </gj-tooltip>
            </div>
            <div class="content-row-col">
              <gj-tooltip content="邮件暂不可接收">
                <el-switch disabled v-model="data.topUpWarning.mail"></el-switch>
              </gj-tooltip>
            </div>
            <div class="content-row-col">
              <gj-tooltip content="微信暂不可接收">
                <el-switch disabled v-model="data.topUpWarning.wechat"></el-switch>
              </gj-tooltip>
            </div>
          </div>

          <div class="message-content-row message-content-row-content message-solid">
            <div style="flex: 1; padding-left: 40px;">
              店铺授权失效
            </div>
            <div class="content-row-col">
              <gj-tooltip content="系统默认不可取消">
                <el-switch disabled @change="debounceUpdate" v-model="data.shopAuthExpires.system"></el-switch>
              </gj-tooltip>
            </div>
            <div class="content-row-col">
              <gj-tooltip content="邮件暂不可接收">
                <el-switch disabled v-model="data.shopAuthExpires.mail"></el-switch>
              </gj-tooltip>
            </div>
            <div class="content-row-col">
              <gj-tooltip content="微信暂不可接收">
                <el-switch disabled v-model="data.shopAuthExpires.wechat"></el-switch>
              </gj-tooltip>
            </div>
          </div>

          <div class="message-content-row message-content-row-content message-solid">
            <div style="flex: 1; padding-left: 40px;">
              广告分时执行结果
            </div>
            <div class="content-row-col">
              <gj-tooltip content="系统默认不可取消">
                <el-switch disabled @change="debounceUpdate" v-model="data.adsStrategyResult.system"></el-switch>
              </gj-tooltip>
            </div>
            <div class="content-row-col">
              <gj-tooltip content="邮件暂不可接收">
                <el-switch disabled v-model="data.adsStrategyResult.mail"></el-switch>
              </gj-tooltip>
            </div>
            <div class="content-row-col">
              <gj-tooltip content="微信暂不可接收">
                <el-switch disabled v-model="data.adsStrategyResult.wechat"></el-switch>
              </gj-tooltip>
            </div>
          </div>

          <div class="message-content-row message-content-row-content">
            <div style="flex: 1; padding-left: 40px;">
              自动规则执行结果
            </div>
            <div class="content-row-col">
              <gj-tooltip content="系统默认不可取消">
                <el-switch disabled @change="debounceUpdate" v-model="data.adsAutoRuleResult.system"></el-switch>
              </gj-tooltip>
            </div>
            <div class="content-row-col">
              <gj-tooltip content="邮件暂不可接收">
                <el-switch disabled v-model="data.adsAutoRuleResult.mail"></el-switch>
              </gj-tooltip>
            </div>
            <div class="content-row-col">
              <gj-tooltip content="微信暂不可接收">
                <el-switch disabled v-model="data.adsAutoRuleResult.wechat"></el-switch>
              </gj-tooltip>
            </div>
          </div>
        </div>

        <gj-area-title>运营消息</gj-area-title>
        <div class="message-content" style="margin-bottom: 0">
<!--          <div class="message-content-row message-content-row-title">-->
<!--            <div style="flex: 1; padding-left: 40px;">-->
<!--              消息内容-->
<!--            </div>-->
<!--            <div class="content-row-col">-->
<!--              站内-->
<!--            </div>-->
<!--            <div class="content-row-col">-->
<!--              邮件-->
<!--            </div>-->
<!--            <div class="content-row-col">-->
<!--              微信-->
<!--            </div>-->
<!--          </div>-->
<!--          <div class="message-content-row message-content-row-content message-solid">-->
<!--            <div style="flex: 1; padding-left: 40px;">-->
<!--              高销低库存预警-->
<!--              <gj-help>-->
<!--                高销：昨日销量TOP10-->
<!--                <br/>-->
<!--                低库存：可售天数低于14天-->
<!--              </gj-help>-->
<!--            </div>-->
<!--            <div class="content-row-col">-->
<!--              <el-switch @change="debounceUpdate" v-model="data.saleInventory.system"></el-switch>-->
<!--            </div>-->
<!--            <div class="content-row-col">-->
<!--              <gj-tooltip content="邮件暂不可接收">-->
<!--                <el-switch disabled v-model="data.saleInventory.mail"></el-switch>-->
<!--              </gj-tooltip>-->
<!--            </div>-->
<!--            <div class="content-row-col">-->
<!--              <el-switch @change="debounceUpdate" v-model="data.saleInventory.wechat"></el-switch>-->
<!--            </div>-->
<!--          </div>-->
<!--          <div class="message-content-row message-content-row-content message-solid">-->
<!--            <div style="flex: 1; padding-left: 40px;">-->
<!--              今日差评预警-->
<!--              <gj-help>差评：Review星级为1-3星</gj-help>-->
<!--            </div>-->
<!--            <div class="content-row-col">-->
<!--              <el-switch @change="debounceUpdate" v-model="data.review.system"></el-switch>-->
<!--            </div>-->
<!--            <div class="content-row-col">-->
<!--              <gj-tooltip content="邮件暂不可接收">-->
<!--                <el-switch disabled v-model="data.review.mail"></el-switch>-->
<!--              </gj-tooltip>-->
<!--            </div>-->
<!--            <div class="content-row-col">-->
<!--              <el-switch @change="debounceUpdate" v-model="data.review.wechat"></el-switch>-->
<!--            </div>-->
<!--          </div>-->
<!--          <div class="message-content-row message-content-row-content message-solid">-->
<!--            <div style="flex: 1; padding-left: 40px;">-->
<!--              店铺绩效异常预警-->
<!--            </div>-->
<!--            <div class="content-row-col">-->
<!--              <el-switch @change="debounceUpdate" v-model="data.performance.system"></el-switch>-->
<!--            </div>-->
<!--            <div class="content-row-col">-->
<!--              <gj-tooltip content="邮件暂不可接收">-->
<!--                <el-switch disabled v-model="data.performance.mail"></el-switch>-->
<!--              </gj-tooltip>-->
<!--            </div>-->
<!--            <div class="content-row-col">-->
<!--              <el-switch @change="debounceUpdate" v-model="data.performance.wechat"></el-switch>-->
<!--            </div>-->
<!--          </div>-->
          <div class="message-content-row message-content-row-content message-solid">
            <div style="flex: 1; padding-left: 40px;">
              跟卖监控预警
            </div>
            <div class="content-row-col">
              <el-switch @change="debounceUpdate" v-model="data.offerMonitor.system"></el-switch>
            </div>
            <div class="content-row-col">
              <gj-tooltip>
                <el-switch @change="debounceUpdate" v-model="data.offerMonitor.mail"></el-switch>
              </gj-tooltip>
            </div>
            <div class="content-row-col">
              <el-switch @change="debounceUpdate" v-model="data.offerMonitor.wechat"></el-switch>
            </div>
          </div>
          <div class="message-content-row message-content-row-content">
            <div style="flex: 1; padding-left: 40px;">
              品牌广告审核通知
            </div>
            <div class="content-row-col">
              <el-switch @change="debounceUpdate" v-model="data.adsSbReview.system"></el-switch>
            </div>
            <div class="content-row-col">
              <gj-tooltip content="邮件暂不可接收">
                <el-switch @change="debounceUpdate" v-model="data.adsSbReview.mail" disabled></el-switch>
              </gj-tooltip>
            </div>
            <div class="content-row-col">
              <el-switch @change="debounceUpdate" v-model="data.adsSbReview.wechat"></el-switch>
            </div>
          </div>
        </div>
      </div>
      <div class="setting-btn">
        <gj-button type="primary" @click="routerMsg('/setting/argument',{activeTab: 'warningConfig'})"  v-if="$permission('msgSetting:edit')">预警消息设置点这里
        </gj-button>
      </div>
    </div>
  </div>
</template>

<script>
import {getMessageSetting, updateMessageSetting} from "@/api/message";
import {responseMixin} from "@/minxins";

export default {
  name: "message-setting",
  mixins: [responseMixin],
  created() {
    getMessageSetting()
        .then((data) => {
          for (let key in data) {
            this.data[key] = data[key];
          }
        })
  },
  data() {
    return {
      data: {
        publicity: {
          mail: false,
          system: false,
          wechat: false
        },
        review: {
          mail: false,
          system: false,
          wechat: false
        },
        performance: {
          mail: false,
          system: false,
          wechat: false
        },
        saleInventory: {
          mail: false,
          system: false,
          wechat: false
        },
        shopAuthExpires: {
          mail: false,
          system: false,
          wechat: false
        },
        adsStrategyResult:{
          mail: false,
          system: false,
          wechat: false
        },
        adsAutoRuleResult:{
          mail: false,
          system: false,
          wechat: false
        },
        topUpWarning: {
          mail: false,
          system: false,
          wechat: false
        },
        offerMonitor: {
          mail: false,
          system: false,
          wechat: false
        },
        adsSbReview: {
          mail: false,
          system: false,
          wechat: false
        },
      },
      debounceUpdate: this._.debounce(this.updateMessage, 500),
    }
  },
  methods: {
    routerMsg(path, query) {
      this.$router.push({path: path, query: query});
    },
    updateMessage() {
      updateMessageSetting(this.data)
          .then((res) => {
            this.$gjResponseHandle(res, () => {
              this.$gjMessage.success('操作成功');
            })
          });
    },
  }
}
</script>

<style scoped>
.message-setting-layout {
  box-sizing: border-box;
  height: 100%;
}

.message-content {
  border: 1px solid #D8DADD;
  width: 100%;
  margin-bottom: 20px;
}

.message-content-row {
  display: flex;
  flex-direction: row;
  width: 100%;
  align-items: center;
}

.message-content-row-title {
  border-bottom: 1px solid #D8DADD;
  font-size: 14px;
  height: 40px;
  background: #F6F8FB;
}

.message-content-row-title > div {
  font-weight: bold;
}

.message-content-row-content {
  height: 50px;
  font-size: 12px;
}

.content-row-col {
  width: 200px;
}

.message-setting-content {
  background: #ffffff;
  height: 100%;
  padding: 16px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
}

.message-solid {
  border-bottom: 1px solid #E4E5E6;
}

.setting-btn {
  height: 60px;
  display: flex;
  align-items: center;
}
</style>
